import React from 'react'

export default function FloatingCTAs() {
  return (
    <>
      {/* Desktop Floating Side Widget (bottom right on large screens) */}
      <aside 
        aria-label="Hurtig kontakt"
        className="hidden md:flex fixed bottom-6 right-6 z-30 flex-col gap-3 group"
      >
        <a
          href="tel:52506794"
          className="contact-no-break flex items-center gap-3 bg-[#285F41] hover:bg-[#357753] text-white px-4 py-3 rounded-full shadow-lg border border-[#3A614A]/40 transition-all transform hover:-translate-y-0.5 active:translate-y-0"
          title="Ring til Elses skrub og skur"
        >
          <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center shrink-0">
            <i className="fa-regular fa-phone text-emerald-300 text-sm" aria-hidden="true"></i>
          </div>
          <span className="text-xs font-bold tracking-wide pr-1">52 50 67 94</span>
        </a>

        <a
          href="mailto:else_christiansen@godmail.dk"
          className="contact-no-break flex items-center gap-3 bg-white hover:bg-[#F2F6F3] text-[#285F41] px-4 py-3 rounded-full shadow-lg border border-[#D2E0D6] transition-all transform hover:-translate-y-0.5 active:translate-y-0"
          title="Send mig en e-mail"
        >
          <div className="w-8 h-8 rounded-full bg-[#EEF3EF] flex items-center justify-center shrink-0">
            <i className="fa-regular fa-envelope text-[#285F41] text-sm" aria-hidden="true"></i>
          </div>
          <span className="text-xs font-bold tracking-wide pr-1">Send e-mail</span>
        </a>
      </aside>

      {/* Mobile Fixed Bottom Bar (Visible strictly on mobile screens < 768px) */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#FAF9F5]/95 backdrop-blur-md border-t border-[#D9E3DC] p-3 shadow-2xl flex items-center gap-2">
        <a
          href="tel:52506794"
          className="contact-no-break flex-1 flex items-center justify-center gap-2 bg-[#285F41] text-white font-semibold text-sm py-3 px-4 rounded-xl shadow-sm hover:bg-[#357753] active:scale-[0.98] transition-all"
        >
          <i className="fa-solid fa-phone text-emerald-300" aria-hidden="true"></i>
          <span>Ring: 52 50 67 94</span>
        </a>

        <a
          href="mailto:else_christiansen@godmail.dk"
          className="contact-no-break flex-1 flex items-center justify-center gap-2 bg-[#EEF3EF] text-[#285F41] font-semibold text-sm py-3 px-4 rounded-xl border border-[#D2E0D6] hover:bg-[#E2ECE4] active:scale-[0.98] transition-all"
        >
          <i className="fa-regular fa-envelope text-[#285F41]" aria-hidden="true"></i>
          <span>Send e-mail</span>
        </a>
      </div>
    </>
  )
}
